var _path, _path2, _rect, _circle, _circle2, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMekoya1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 100 C220 100 180 180 180 240 C180 320 300 500 300 500 C300 500 420 320 420 240 C420 180 380 100 300 100 Z",
    fill: "#0077C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 140 C240 140 210 190 210 240 C210 300 300 450 300 450 C300 450 390 300 390 240 C390 190 360 140 300 140 Z",
    fill: "#FFFFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 210,
    width: 80,
    height: 40,
    rx: 8,
    fill: "#0077C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 275,
    cy: 250,
    r: 8,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 250,
    r: 8,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 550,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    fill: "#0077C8",
    textAnchor: "middle"
  }, "MEKOYA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 590,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#0077C8",
    textAnchor: "middle"
  }, "PARKING APP")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMekoya1);
export default __webpack_public_path__ + "static/media/Mekoya1.ef1f0f5e6e9537d4324f640a504f49c0.svg";
export { ForwardRef as ReactComponent };